export default __webpack_public_path__ + "static/media/06.e157c84c.jpg";